import store from '..'
import axios from 'axios'
import API from '@/common/api'
import regExp from '../../common/regExp'
import Compressor from 'compressorjs'
import moment from 'moment-timezone'

// 태블릿 디바이스에서 tel링크 무효화 시키기 위한 isMobile check
const deviceType = () => {
  const ua = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile'
  }
  return 'desktop'
}

export default {
  namespaced: true,
  state: {
    link: {}
  },
  mutations: {
  },
  actions: {
    async getClientIp ({ state }) {
      try {
        const response = await axios.get('https://api.ipify.org?format=json')
        return response
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getSmartVoice ({ state }, groupId) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-smart-voice',
          func: 'get-voices',
          siteid: siteInfo.site,
          groupId: groupId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getShortUrl ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-short-link',
          func: 'get-link',
          path: data.url,
          days: data.days || 1
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async setImage ({ state }, data) { // image compressor
      if (data) {
        const file = data.file
        return new Promise((resolve, reject) => {
          (() => new Compressor(file, {
            quality: 0.6,
            maxWidth: 1920,
            maxHeight: 1920,
            success: (result) => {
              return resolve(result)
            },
            error: (err) => {
              return reject(err)
            }
          }))()
        })
      }
    },
    async uploadFile ({ state }, data) {
      const requestId = `guest.${store.state.authentication.site}`
      const fileId = data.id
      const getUrlParams = function () {
        const params = {}
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (_str, key, value) {
          params[key] = value
        })
        return params
      }
      const BASE_URL = getUrlParams().debug && getUrlParams().debug === '1'
        ? process.env.VUE_APP_API_ORIGIN_DEBUG
        : window.location.origin.includes('localhost') ? 'https://edit.istay.io' : window.location.origin
      function fileReader (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = (e) => {
            const bytes = Array.from(new Uint8Array(reader.result)).length
            const max = 1024 * 1024 * 4
            if (bytes > max) {
              alert(store.state.service.locale.data.validate_upload_file_size)
              return false
            } else {
              resolve({
                name: file.name,
                format: file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase(),
                file: reader.result
              })
            }
          }
          reader.readAsArrayBuffer(file)
        })
      }
      const res = await fileReader(data.file)
      const fileFormat = res.format
      await axios({
        method: 'post',
        url: `${BASE_URL}/castit/file?id=${requestId}&file=files/${fileId}.${fileFormat}`,
        headers: {
          'Content-type': 'application/octet-stream'
        },
        data: res.file
      })
      const siteid = store.state.authentication.site
      const fileName = res.name
      const fileFormat1 = res.format
      const fileUrl = `https://istay-guestvalet-file.s3.ap-northeast-2.amazonaws.com/${siteid}/files/${fileId}.${fileFormat1}`
      return {
        name: fileName,
        format: fileFormat1,
        source: fileUrl
      }
    },
    async eventTrigger ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-event-trigger',
          func: data.func,
          siteid: siteInfo.site,
          spaceid: siteInfo.space,
          ota: siteInfo.k
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return ex && ex.response && ex.response.data
      }
    }
  },
  getters: {
    /**
     * 실제 링크데이터가 있는 객체를 target으로 넘겨받는다
     * (공통)링크데이터 target 데이터 구조
     * target: boolean (true ? _blank : _self)
     * url: {lang: string, ...} (return active lang value)
     */
    setLink: () => target => {
      const type = target.type
      const lang = store.state.common.lang.current
      const hash = window.location.hash
      const params = new URL(window.location.href).searchParams
      const contentOnly = (target.frame_false || params.get('frame') === 'false') ? '&frame=false' : ''
      const publicPath = window.location.href.replace(hash, '') + contentOnly + '#'
      let url = ''

      function replaceLinkVars (urlStr, authentication) {
        let vars = []
        let arr = []
        const pattern = /(?=\{\{)(.*?)(?=\}\})/g
        const split = urlStr && urlStr.split(pattern)
        split.forEach(function (itemStr, index) {
          itemStr = itemStr.replaceAll(/{|}/g, '')
          /**
            * src에 파라미터 정보의 변수가 있는 경우
            * 파라미터에서 해당 정보를 가져와서 치환
            */
          if (itemStr.startsWith('params-') && authentication) {
            const paramsKey = itemStr.replace('params-', '')
            const paramsValue = authentication[paramsKey]
            arr.push(paramsValue)
          } else {
            arr.push(itemStr)
          }
        })
        return arr.join('')
      }
      /**
       * 링크타입이 페이지일 때
       * 연결된 페이지가 없으면 #
       * 있으면 페이지 라우터
       * 새창이면 퍼블릭패스 추가하여
       */
      if (type === 'page') {
        if (!target.pageId || target.pageId.trim() === '') {
          url = `${contentOnly}#`
        } else {
          url = `${target.target ? publicPath : contentOnly + '#'}/${lang}/page/${target.pageId}`
        }
      } else if (type === 'shop') {
        const shopOrStore = target.shopToStore ? 'store' : 'shop'
        if (!target.shopPageId || target.shopPageId.trim() === '') {
          url = `${contentOnly}#`
        } else {
          url = target.shopCategoryId
            ? `${contentOnly}#/${lang}/${shopOrStore}/${target.shopPageId}/${target.shopCategoryId}`
            : `${contentOnly}#/${lang}/${shopOrStore}/${target.shopPageId}`
        }
      } else if (type === 'product') {
        if (!target.productId || target.productId.trim() === '') {
          url = `${contentOnly}#`
        } else {
          url = target.productCategory
            ? `${contentOnly}#/${lang}/product/${target.productId}/${target.productCategory}`
            : `${contentOnly}#/${lang}/product/${target.productId}`
        }
      } else if (type === 'reservation') {
        if (!target.reservationId || target.reservationId.trim() === '') {
          url = `${contentOnly}#`
        } else {
          url = `${contentOnly}#/${lang}/reservation/${target.reservationId}`
        }
      /**
       * 링크타입이 sep일 때
       * 연결된 sep 페이지가 없으면 #
       * 있으면 해당 sep 페이지
       */
      } else if (type === 'sep') {
        if (target.sepId.trim() === '' || typeof (target.sepId) === 'undefined') {
          url = `${contentOnly}#`
        } else {
          url = `${contentOnly}#/${lang}/page/${target.sepId}`
        }
      /**
       * 링크타입이 아웃링크일 때
       * 입력한 url 그대로 연결
       */
      } else if (type === 'outlink') {
        Object.keys(target.url).forEach(function (x) {
          if (target.url[x].trim() === '') {
            target.url[x] = '#'
          }
          // 와이파이형 태블릿에서 tel링크는 막아야함
          if (target.url[x].includes('tel:') && deviceType() !== 'mobile') {
            target.url[x] = '#'
          }
          /**
           * 외부링크에 개인화 정보를 담아 내보낼 때
           * ex) 호텔 멤버십 사이트에서 key 값이 필요한 경우
           * {{key}} 형태로 작성하면 ota key로 변환
           */
          if (target.url[x].includes('{{key}}')) {
            const key = store.getters['authentication/getAuthInfo'].k
            const targetUrl = target.url[x]
            target.url[x] = targetUrl.replace('{{key}}', key)
          }
          /**
           * 단순 otakey가 아닌 파라미터 정보가 필요할 때
           * params-key 를 키로 하는 값을 치환
           */
          if (target.url[x].includes('{{') && target.url[x].includes('}}')) {
            const authentication = store.getters['authentication/getAuthInfo']
            if (authentication) {
              target.url[x] = replaceLinkVars(target.url[x], authentication)
            }
          }
        })
        url = target.url[lang]
      /**
       * 링크타입이 바로가기일 때:: 바로가기는 캐스트잇 내 페이지 외 제공되는 서비스 항목임
       * ex. 쿠폰, 지역정보
       * 연결된 바로가기가 없으면 #
       * 있으면 해당 서비스 라우터
       * 새창이면 퍼블릭패스 추가하여
       */
      } else if (type === 'shortcut') {
        if (target.shortcutId === '' || typeof (target.shortcutId) === 'undefined') {
          url = `${contentOnly}#`
        } else if (target.shortcutId === 'talk') {
          url = `&talk=true#/${lang}`
        } else if (target.shortcutId.split('/')[0] === 'waitingcall') {
          url = `${contentOnly}#/${lang}/waitingcall/${target.shortcutId.split('/')[1]}`
        } else {
          url = `${target.target ? publicPath : contentOnly + '#'}/${lang}/${target.shortcutId}`
          // 지역정보는 shortcutId를 localinfo로 갖고 지역정보 카테고리를 갖고있거나 갖고있지 않을 수 있다
          if (target.shortcutId === 'localinfo' && !!target.localinfotype) {
            url += `/${target.localinfotype}`
          }
        }
      /**
       * 링크타입이 기능일 때:: 기능은 링크이동 없이 제어 등 기능을 수행하는 항목임
       * ex. 객실키(room control - door)
       */
      } else if (type === 'func') {
        if (target.funcId === '' || typeof (target.funcId) === 'undefined') {
          url = ''
        } else {
          url = target.funcId
        }
      /**
       * 링크타입이 외부서비스 연동일 때:: 현재는 GV만 있음
       * 들고온 파라미터 정보 그대로 전달해줌
       * 단 언어는 현재 보고있는 언어로 변경하여 전달
       * GV 이용 가능한 최소한의 인증 정보는 key, siteid, space
       * 모두 유효하면 파라미터의 baseurl+channel로 연결
       * 더이상 사용하지 않음
       * (230206) 코드삭제
       */
      } else if (type.includes('interlock')) {
        url = `${contentOnly}#`
      }
      const result = {
        href: url,
        target: target.target ? '_blank' : '_self',
        ...url && {
          linkInfo: getLinkParams(url)
        }
      }
      function getLinkParams (input) {
        let url
        try {
          url = new URL(input)
        } catch {
          const baseUrl = window.location.origin
          if (input.startsWith("/")) {
            // path일 경우 기본 호스트로 전체 URL 생성
            url = new URL(baseUrl + input)
          } else if (input.startsWith("?")) {
            // 쿼리 스트링일 경우 기본 호스트 + 기본 경로와 함께 전체 URL 생성
            url = new URL(baseUrl + "/" + input)
          }
        }
        if (url) {
          const queryObject = {}
          url.searchParams.forEach((value, key) => {
            queryObject[key] = value
          })
          return {
            host: url.host,
            params: queryObject
          }
        }
      }
      return result
    },
    getCouponDiscountPrice: () => (coupons, value) => {
      let price = value
      const discountCoupons = coupons ? coupons.filter(x => {
        return x.activeCoupon && x.payload && x.payload.discount && x.payload.discountType && x.payload.discountValue
      }).map(x => {
        return {
          type: x.payload.discountType,
          value: x.payload.discountValue
        }
      }) : null
      const priceCoupons = discountCoupons ? discountCoupons.filter(x => x.type === 'price').map(x => parseFloat(x.value) * -1) : null
      const rateCoupons = discountCoupons ? discountCoupons.filter(x => x.type === 'rate').map(x => parseFloat(x.value) * -1) : null
      if (priceCoupons && priceCoupons.length) {
        price += priceCoupons.reduce((a, b) => (a + b), 0)
      }
      if (rateCoupons && rateCoupons.length) {
        for (let i = 0; i <= rateCoupons.length - 1; i++) {
          const rate = rateCoupons[i]
          price += price * Number(rate) / 100
        }
      }
      if ((priceCoupons && !priceCoupons.length) && (rateCoupons && !rateCoupons.length)) {
        price = null
      }
      return price !== null && price !== undefined ? {
        normalPrice: value, // 할인전 금액
        priceDiscount: value - price, // 할인 금액
        price: price // 할인 적용된  최종 금액
      } : null
    },
    /**
     * guest type 정보로
     * 할인된 금액 return
     * guestType: object
     * value: Number or string (price)
     */
    getGuestTypePrice: (state, getters, rootState, rootGetters) => (guestType, value) => {
      let price = value
      let priceDiscount
      let discountPrice = null
      let dutyFree
      const getGuestUserInfo = rootGetters['guest/getGuestUserInfo']
      const isDutyFree = getGuestUserInfo && getGuestUserInfo.dutyFree
      function priceFormat (price) {
        const code = store.getters['common/getSetting'].currency.toUpperCase()
        return regExp.priceFormat(price, code)
      }
      if (guestType.percent && guestType.percent.active) {
        const incDec = guestType.percent.incDec === 'dec' ? '-' : '+'
        const discount = `${incDec}${guestType.percent.value}`
        priceDiscount = `${discount}%`
        // 할인율일 때는 할인되는 절대금액을 따로 추가
        discountPrice = `${incDec}${price * Number(guestType.percent.value) / 100}`
        price += price * Number(discount) / 100
      } else if (guestType.price && guestType.price.active) {
        const incDec = guestType.price.incDec === 'dec' ? '-' : '+'
        const discount = `${incDec}${guestType.price.value}`
        priceDiscount = priceFormat(Number(discount))
        discountPrice = `${incDec}${Number(guestType.percent.value)}`
        price += Number(discount)
      }
      if (isDutyFree) {
        price = regExp.priceDutyFree(price)
      }
      return { price: price, priceDiscount: priceDiscount, normalPrice: value, ...discountPrice && { discountPrice: discountPrice } }
    },
    /**
     * 이용가능시간 검사
     * day.time: array
     * 지금 시간이 오늘 여러 시간중에 해당되는지
     */
    getAvailableDay: () => (day) => { // element of available array
      let result = false
      const timezone = store.state.siteInfo.timezoneId || ''
      const timeNow = timezone ? getTimes(moment().tz(timezone).format('HH:mm')) : getTimes(moment().format('HH:mm'))
      function timeDiff (now, from, to) { // number, number, number
        return now >= getTimes(from) && now <= getTimes(to)
      }
      function getTimes (time) {
        return Number(time.replace(':', ''))
      }
      // day.time 길이가 반드시 있어야 available = true로 넘어옴
      if (day.available) {
        if (day.time && day.time.length) {
          for (let i = 0; i < day.time.length; i++) {
            const time = day.time[i]
            if (timeDiff(timeNow, time.from, time.to)) {
              result = true
            }
          }
        }
      } else if (!day.time) {
        result = true
      }
      return result
    },
    /**
     * 쿠폰 사용처리 전 유효검사가 중간중간 필요하기 때문에
     * 필요한 시점에 쿠폰조회 후 유효검사 해야함
     */
    validateCoupon: () => (couponList, iids) => {
      const customCnt = {}
      const couponIids = couponList && couponList.length ? couponList.map(x => x.iid) : []
      function getCustomName (iid) {
        // custom^test^aa9^001^PIZZA2^2022-09-01^20220901^410^fbc7c8f8-1409-41e1-bc9d-b216613fd95a
        iid = decodeURIComponent(iid).split('^')
        return iid.filter((x, i) => i < iid.length - 1).join('_')
      }
      iids = iids.map(x => x.startsWith('custom') ? getCustomName(x) : x)
      for (let i = 0; i < iids.length; i++) {
        let iid = iids[i]
        if (iid.startsWith('custom')) {
          const couponName = iid
          if (customCnt[couponName]) {
            customCnt[couponName] += 1
          } else {
            customCnt[couponName] = 0
          }
          iids[i] = `${couponName}_${customCnt[couponName]}`
        }
      }
      return iids.filter(x => !couponIids.includes(x)).length === 0
    },
    getMobilityProductName: () => (name) => {
      let productName = ''
      switch (name) {
        case 'NXT':
          productName = 'tada_next'
          break
        default:
          productName = name
      }
      return productName
    },
    excludeLangs: () => (langObj) => {
      const useLangs = store.state.common.setting.lang.usable
      return Object.fromEntries(
        Object.entries(langObj).filter(([key]) => useLangs.includes(key))
      )
    },
    getPriceFormatter: (state, getters, rootState, rootGetters) => (price, currency, forceFormat = false) => {
      const setting = store.state.common && store.state.common.setting
      const code = currency || (setting && setting.currency && setting.currency.toUpperCase())
      const lang = rootGetters['common/getLang'] || 'ko'

      const disabledCurrencySymbol = setting && setting.disabledCurrencySymbol === true
      const isUnitType = setting && setting.displayCurrencyType === 'unit'
      const unitTemplate = isUnitType &&
        setting &&
        setting.displayCurrencyUnit &&
        setting.displayCurrencyUnit[lang]

      const purePrice = regExp.priceFormat(price, code, true)

      // 1. 표기 안함이면서 !forceFormat 이면 무조건 금액만 표시
      if (disabledCurrencySymbol && !forceFormat) {
        return purePrice
      }

      // 2. forceFormat이거나 원래 표기 허용 상태일 때, unit 타입이면 커스텀 텍스트 우선
      if (isUnitType) {
        if (unitTemplate && unitTemplate.indexOf('{price}') > -1) {
          return unitTemplate.replace('{price}', purePrice)
        }
        // 템플릿 없거나 {price} 없으면 숫자만
        return purePrice
      }

      // 3. 그 외 기본 통화 포맷
      return regExp.priceFormat(price, code, false)
    }
  }
}
